<template>
  <v-form ref="formRef" v-model="valid">
    <v-combobox
      v-model="localValue.recipients"
      :items="recipients"
      :rules="[atLeastOneIsRequired(), emailRule()]"
      :disabled="disabled"
      class="mb-2"
      variant="outlined"
      multiple
      :placeholder="$t('ticketDetails.recipients')"
      :label="$t('ticketDetails.recipients')"
      :aria-label="$t('ticketDetails.recipients')"
    >
      <template v-slot:chip="{ props, item }">
        <v-chip
          v-bind="props"
          :closable="true"
          variant="flat"
          size="default"
          close-icon="$closeCircle"
          color="indigo-faint"
          :text="item.title"
        >
          <div class="d-flex align-center">
            <span class="ml-1 mr-2">{{ item.title }}</span>
          </div>
        </v-chip>
      </template>
      <template #item="{ item, props }">
        <v-list-item v-bind="props" :title="item.title"> </v-list-item>
      </template>
    </v-combobox>

    <v-textarea
      v-model="localValue.contactMessage"
      variant="outlined"
      :disabled="disabled"
      :label="$t('modals.contactUser.placeholder')"
      :rules="[required()]"
      :placeholder="$t('modals.contactUser.placeholder')"
    >
    </v-textarea>

    <v-checkbox
      v-model="localValue.includeEventDetails"
      :disabled="disabled"
      :label="$t('modals.contactUser.includeEventDetails')"
    >
    </v-checkbox>
  </v-form>
</template>

<script lang="ts">
import { defineComponent, ref, type PropType, toRefs, computed } from "vue";
import { atLeastOneIsRequired, emailRule, required } from "@/_helpers/validators.ts";
import type { VuetifyFormRef } from "@/types.ts";
import type { ContactUserFormData } from "@/_helpers/ticket-helpers.ts";

import { useTwoWayBinding } from "@/composables/useTwoWayBinding.ts";

export default defineComponent({
  props: {
    modelValue: {
      type: Object as PropType<ContactUserFormData>,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:modelValue", "update:valid"],
  setup(props, { emit }) {
    const formRef = ref<VuetifyFormRef>();
    const { modelValue } = toRefs(props);
    const localValue = useTwoWayBinding(modelValue, (value) => {
      emit("update:modelValue", value);
    });

    const recipients = computed(() => modelValue.value.recipients || []);

    const valid = ref(false);

    const validate = async () => {
      const isValid = await formRef.value!.validate();
      return isValid;
    };

    return {
      formRef,
      recipients,
      localValue,
      required,
      atLeastOneIsRequired,
      emailRule,
      validate,
      valid,
    };
  },
});
</script>
